import { useNavigate } from 'react-router-dom';
import '../../css/signin/Signin_verify.css'
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { domain } from '../Links/Links';

function Signin_verify({theme}) {
    const country_code = sessionStorage.getItem('country_code');
    const phone_number = sessionStorage.getItem('phone_number');
    const otp_token = sessionStorage.getItem('otp_token');
    const [otpInput, setOtpInput] = useState('')
    const isFilled = otpInput.length == 5
    const [submitButtonStatus, setSubmitButtonStatus] = useState(false);
    const [invalidOTP, setInvalidOTP] = useState(false);
    const navigate = useNavigate();

    const { t } = useTranslation();

    const inputRef = useRef(null);

    useEffect(() => {
        document.title = t('Hiket, Signin verify');
        if (inputRef.current) {
            inputRef.current.focus();
        }

        const handleKeydown = (event) => {
            if (event.key === 'Enter') {
                const next_button = document.querySelector('.fdeerrevcd');
                next_button.click();
            }
        }
        window.addEventListener('keydown', handleKeydown);

        return () => {
            window.removeEventListener('keydown', handleKeydown);
        }


    }, []);

    return (

        <div className="djjjfmvc3">

            <div className='kf003ikk1'>

                <div className="fjjjxkks2">
                    <h1 className="pxiiifjb3">
                        {phone_number}
                    </h1>
                    <h2 className="fkkkgjmbv">
                        {t('Enter the verification code sent to your phone')}
                    </h2>

                </div>

                <input type="tel" inputMode="numeric" pattern="[0-9]" className={`input text_align_center ${theme} ${invalidOTP ? 'error' : ''}`} ref={inputRef}
                onChange={(e) => setOtpInput(e.target.value)}
                ></input>
                {invalidOTP && (
                    <div className='input_error_div'>{t('The code entered is invalid')}</div>
                )}
                <button className={`submit_button fdeerrevcd ${theme} ${isFilled? 'active' : theme}`}
                onClick={() => {

                    if (isFilled) {
                        setSubmitButtonStatus(true);

                        var xhr = new XMLHttpRequest();
                        xhr.open('POST' , domain + '/signin_verify_api/')
                        xhr.withCredentials = true;
                        xhr.onreadystatechange = () => {
                            if (xhr.readyState === 4 && xhr.status === 200) {
                                const data = JSON.parse(xhr.responseText);
                                if (data.status == 'confirmation') {
                                    document.cookie = 'session_status=true; max-age=32000000; path=/';
                                    navigate('/');
                                    window.location.reload();
                                } else if (data.invalid_otp) {
                                    setInvalidOTP(true);
                                    setSubmitButtonStatus(false);
                                    setTimeout(() => {
                                        setInvalidOTP(false);
                                    }, 3000);
                                }
                            }
                        }
                        xhr.setRequestHeader('Content-Type' , 'application/json');
                        
                        var location = 'Iran'; 
                        navigator.geolocation.getCurrentPosition(
                            (positon) => {
                                location = positon.coords.latitude + positon.coords.longitude;
                            }
                        )
                        var data = JSON.stringify({
                            otp: otpInput,
                            country_code : country_code,
                            phone_number: phone_number,
                            otp_token: otp_token,
                            system_name: navigator.userAgent,
                            app_name:'Web',
                            location: location,
                        })
                        xhr.send(data);
                    }
                }}
                
                >
                    {submitButtonStatus ? (
                        <img src='/icons/loading.png' className='jfeic35fs rotate icon'></img>
                    ) : (
                        'Submit'
                    )}
                    
                    </button>
            </div>
            
        </div>
    )
}

export default Signin_verify